import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/tDeWED6PqefAybes6s7FbC/miradas_que_enamoran_1.png', 'https://cdn.magicpatterns.com/uploads/kvyd2iPa33NF6FU2qSpqQD/miradas_que_enamoran_2.png', 'https://cdn.magicpatterns.com/uploads/2eKpvrAEsV8nCjcpPmott3/mirada_que_enamora_3.png', 'https://cdn.magicpatterns.com/uploads/nLMMUHEZXJ3Fn7wzbESkfL/mirada_que_enamora_4.png', 'https://cdn.magicpatterns.com/uploads/uqtVtGfU62c5ByKuZYAKgn/miradas_que_enamoran_6.png', 'https://cdn.magicpatterns.com/uploads/jnCG4rAAiMWEakr9UQgGWg/Captura_de_Pantalla_2026-05-03_a_la(s)_18.13.32.png', 'https://cdn.magicpatterns.com/uploads/6SoaSK1YYpprbpw3zvG8qU/micro_cejas_3.png', 'https://cdn.magicpatterns.com/uploads/sUBcpyJFbRcoeDi6tksCLp/micro_cejas_1.png'];
export function GallerySection() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  return <section className="w-full py-16 bg-[var(--warm-cream)]" data-id="element-95">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-96">
        <div className="text-center mb-10" data-id="element-97">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-98">
            <div className="flex items-center gap-4 mb-4" data-id="element-99">
              <svg className="w-4 h-4 text-[#D4AF37]" viewBox="0 0 24 24" fill="currentColor" data-id="element-100">
                <path d="M12 0L15.5 8.5L24 12L15.5 15.5L12 24L8.5 15.5L0 12L8.5 8.5L12 0Z" data-id="element-101" />
              </svg>
              <h2 className="font-serif text-sm tracking-[0.3em] uppercase text-[#C9956A]" data-id="element-102">
                Portafolio
              </h2>
              <svg className="w-4 h-4 text-[#D4AF37]" viewBox="0 0 24 24" fill="currentColor" data-id="element-103">
                <path d="M12 0L15.5 8.5L24 12L15.5 15.5L12 24L8.5 15.5L0 12L8.5 8.5L12 0Z" data-id="element-104" />
              </svg>
            </div>
            <h3 className="font-serif text-4xl md:text-5xl text-[#2C1810]" data-id="element-105">
              Miradas que Enamoran
            </h3>
          </motion.div>
        </div>

        {/* Carousel */}
        <div className="relative w-full max-w-xs mx-auto aspect-[3/4] rounded-2xl overflow-hidden shadow-xl" data-id="element-106">
          <AnimatePresence mode="wait" data-id="element-107">
            <motion.img key={current} src={images[current]} alt={`Mirada que enamora ${current + 1}`} initial={{
            opacity: 0,
            scale: 1.05
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 1.2,
            ease: 'easeInOut'
          }} className="absolute inset-0 w-full h-full object-cover" data-id="element-108" />
          </AnimatePresence>
          <div className="absolute inset-0 border border-white/20 rounded-2xl z-20 pointer-events-none" data-id="element-109"></div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-3 mt-6" data-id="element-110">
          {images.map((_, index) => <button key={index} onClick={() => setCurrent(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-500 ${index === current ? 'bg-[#D4AF37] scale-110' : 'bg-[#D4AF37]/30 hover:bg-[#D4AF37]/50'}`} aria-label={`Ver imagen ${index + 1}`} data-id="element-111" />)}
        </div>
      </div>
    </section>;
}